import { render, staticRenderFns } from "./TabContents.vue?vue&type=template&id=61b35a5f&"
import script from "./TabContents.vue?vue&type=script&lang=js&"
export * from "./TabContents.vue?vue&type=script&lang=js&"
import style0 from "./TabContents.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TabContents.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports